// import React from "react";
// import { MapContainer, TileLayer, useMap } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import * as L from "leaflet";
// import "leaflet.heat";

// const GeolocationHeatmap = ({ data }) => {
//   const map = useMap();

//   React.useEffect(() => {
//     const heatData = data.map(point => [point.latitude, point.longitude, point.value]);
//     const heatLayer = L.heatLayer(heatData, { radius: 25, blur: 15, maxZoom: 17 });

//     heatLayer.addTo(map);

//     // Define bounds based on your data points
//     const bounds = L.latLngBounds(
//       data.map(point => [point.latitude, point.longitude])
//     );

//     // Set max bounds to prevent sliding too far
//     map.setMaxBounds(bounds);

//     return () => {
//       map.removeLayer(heatLayer);
//     };
//   }, [data, map]);

//   return null;
// };



// export default GeolocationHeatmap;

import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import * as L from "leaflet";

// Marker icon fix for React-Leaflet with Webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const Markers = ({ data }) => {
  const map = useMap();

  useEffect(() => {
    if (data && data.length > 0) {
      const bounds = L.latLngBounds(data.map(point => [point.latitude, point.longitude]));
      map.fitBounds(bounds); // Adjust the map view to fit all markers
    }
  }, [data, map]);

  return (
    <>
      {data.map((point, index) => (
        <Marker
          key={index}
          position={[point.latitude, point.longitude]}
          title={`Value: ${point.value}`}
        >
          <Popup>
            <strong>Coordinates:</strong> {point.latitude}, {point.longitude} <br />
            <strong>Value:</strong> {point.value}
          </Popup>
        </Marker>
      ))}
    </>
  );
};

const GeolocationMap = ({ data }) => {
  return (
    <MapContainer style={{ height: "50vh", width: "100%" }} center={[0, 0]} zoom={2}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {/* <Markers data={data} /> */}
    </MapContainer>
  );
};

export default GeolocationMap;
